export default {
  path: "/post/:id",
  name: "post",
  component: () => import("../components/PostView.vue"),
  meta: {}
};
